/**
 * Count the number of entities and returnes the creation date of the last entity
 * @param data - The data to count
 * @returns The count and the creation date of the last entity
 */
export function count({ data }: { data: { dateCreated: string }[] }) {
    const [{ dateCreated: lastUpdated } = { dateCreated: undefined }] =
        data.sort(
            (a: { dateCreated: string }, b: { dateCreated: string }) =>
                new Date(a.dateCreated).getTime() -
                new Date(b.dateCreated).getTime()
        );
    return [{ timestamp: lastUpdated, value: data.length }];
}
